export const Localization = {
  FORM_TITLE: 'Reset password',
  PASSWORD_INPUT_FLOATING_LABEL_TEXT: 'New password',
  CONFIRM_PASSWORD_INPUT_ERROR_TEXT: 'Passwords do not match',
  CONFIRM_PASSWORD_INPUT_FLOATING_LABEL_TEXT: 'Confirm new password',
  SUBMIT_BUTTON_TEXT: 'Save',
  SESSION_EXPIRED_TITLE: 'This message has expired',
  SESSION_EXPIRED_TEXT: `For security purposes, resetting your password is time-limited.`,
  SESSION_EXPIRED_SUB_TEXT: `Please try again.`,
  SUCCESS_PAGE_TITLE: 'Success!',
  SUCCESS_PAGE_TEXT: 'Password changed successfully',
  GENERAL_ERROR_API: 'There was a problem with the request, please try again later',
  VERIFY_PAGE: {
    REDIRECTION: {
      TITLE: 'Verification in Progress',
      MESSAGE: 'You will be automatically redirected.',
    },
    SUCCESS: {
      TITLE: 'Email verified',
      MESSAGE: 'Your email has been successfully verified.',
      SUB_MESSAGE: 'You can close this window and go back to the app.'
    },
    ERROR: {
      TITLE: 'Something went wrong',
      MESSAGE: 'Try verifying your email again on the {0} application.',
    },
    TOKEN_EXPIRED : {
      TITLE: 'Change email request expired',
      MESSAGE: 'Your request to change the email has already\nexpired. To change your email, please restart the\nprocess through the app. Your previous email\naddress is still used for login. '
    }
  },
};
